import React, { useState } from 'react'
import { Button } from 'react-bootstrap'
import { FaUserCircle, FaEnvelope, FaPhone, FaIdCard, FaBan } from 'react-icons/fa'
import '../../assets/css/FollowersList.css'
import { Link, QrCode } from 'lucide-react'
import BiolinkQRCode from '../biolink-page/BiolinkQRCode'

export default function BlockedList({ blocked, onUnblock, getInitials }) {
    const [qrShow, setQRShow] = useState(false)
    const [qrCode, setQrCode] = useState(false)

    const handleQR = (data) => {
        setQrCode(data)
        setQRShow(true)
    }
    return (
        <>
            {blocked && blocked.length > 0 ? (

                <div className="followers-grid">

                    {blocked?.filter(
                        item =>
                            !(
                                item?.following?._id === localStorage.getItem("id") &&
                                item?.user_status === "block"
                            ) &&
                            !(
                                item?.follower?._id === localStorage.getItem("id") &&
                                item?.user_status === "blocked"
                            )
                    )?.map((follower, index) => {
                        const profileImage = follower?.user_status === 'blocked' ? follower?.follower?.profile?.profile_photo : follower?.user_status === 'block' ? follower?.following?.profile?.profile_photo : null

                        // Handle potential 'undefined' strings and trailing spaces
                        const rawTitle = follower?.user_status === 'blocked' ? follower?.follower?.profile?.title : follower?.following?.profile?.title
                        const rawName = follower?.user_status === 'blocked' ? follower?.follower?.name : follower?.following?.name
                        const validTitle = (rawTitle && rawTitle !== 'undefined' && rawTitle !== 'null') ? rawTitle : null
                        const validName = (rawName && rawName !== 'undefined' && rawName !== 'null') ? rawName : null

                        const userName = (validName || validTitle || 'User').trim()
                        const initials = getInitials(userName)
                        const userId = follower?.user_status === 'blocked' ? follower?.follower?.user_name : follower?.following?.user_name
                        const userEmail = follower?.user?.email || 'N/A'
                        return (
                            <div key={index} className="follower-card">
                                <div className="follower-card-header">
                                    <div className="follower-profile-section">
                                        {profileImage ? (
                                            <img
                                                src={process.env.REACT_APP_BASE_URL + profileImage}
                                                alt={userName}
                                                className="follower-profile-image"
                                                onError={(e) => {
                                                    e.target.style.display = 'none'
                                                    e.target.nextSibling.style.display = 'flex'
                                                }}
                                            />
                                        ) : null}
                                        <div
                                            className="follower-profile-avatar"
                                            style={{ display: profileImage ? 'none' : 'flex' }}
                                        >
                                            {initials}
                                        </div>
                                        <div className="follower-profile-info">
                                            <h6 className="follower-name">{userName}</h6>

                                            <div className='d-flex align-items-center'>
                                                <a
                                                    className="btn btn_qr_code"
                                                    href={process.env.REACT_APP_BASE_URL + `x/${follower?.user?.user_name}`}
                                                    title="Copy URL"
                                                    target="_blank"
                                                >
                                                    <Link size={15} className='mb-1' />
                                                </a>
                                                <button
                                                    className='ms-2 btn btn_qr_code'
                                                    onClick={() => handleQR(follower)}
                                                    title="QR Code"
                                                >
                                                    <QrCode size={15} className='mb-1' />
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="follower-card-body">
                                    <div className="follower-info-item">
                                        <FaIdCard className="follower-info-icon" />
                                        <div className="follower-info-content">
                                            <span className="follower-info-label">Username</span>
                                            <span className="follower-info-value">{userId || 'N/A'}</span>
                                        </div>
                                    </div>

                                    {/* <div className="follower-info-item">
                                        <FaEnvelope className="follower-info-icon" />
                                        <div className="follower-info-content">
                                            <span className="follower-info-label">Email</span>
                                            <span className="follower-info-value">{userEmail}</span>
                                        </div>
                                    </div> */}
                                </div>

                                <div className="follower-card-footer">
                                    <Button
                                        variant="secondary"
                                        className="follower-action-btn follower-unblock-btn w-100"
                                        onClick={() => onUnblock(follower)}
                                    >
                                        <FaBan className="me-2" />
                                        Unblock
                                    </Button>
                                </div>
                            </div>
                        )
                    })}
                </div>
            ) : (
                <div className='empty-followers text-center'>
                    <FaUserCircle size={64} className="empty-icon mb-3" />
                    <h6>No Blocked Users</h6>
                    <p className="text-muted">You haven't blocked any users.</p>
                </div>
            )}
            <BiolinkQRCode qrShow={qrShow} setQRShow={setQRShow} qrCode={qrCode} />
        </>
    )
}

